<template>
  <div>
    <v-autocomplete
      hide-details
      :value="value"
      clearable
      :items="modelTypeList"
      dense
      flat
      filled
      placeholder="Model Number"
      item-color="cyan"
      color="cyan"
      solo
      item-text="name"
      item-value="name"
      :loading="isLoading || loading"
      :disabled="isLoading || disabled"
      :menu-props="{
        contentClass: isLoading ? 'autocomplete-dropdown-menu is-loading' : '',
      }"
      v-bind="$attrs"
      @change="selectModelType"
      @click:clear="$emit('click:clear'), value = null; getModelTypes();"
      @keyup.enter="doSearch"
      :search-input.sync="searchInput"
      :filter="filterModelTypes"
    >
      <template v-slot:no-data>
        <v-list-item>
          <div
            v-if="isLoading"
            class="w-100 d-flex align-center justify-center py-2"
          >
            <v-progress-circular indeterminate color="cyan" />
          </div>
          <v-list-item-title v-else v-html="'No Model Number Found.'" />
        </v-list-item>
      </template>
      <template v-slot:item="{ item }">
        <v-list-item-content>
          <v-list-item-title
            class="text-capitalize font-weight-500 font-size-16 max-content-width"
            >{{ item.name }}
          </v-list-item-title>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { QUERY } from "@/core/services/store/request.module";

export default {
  inheritAttrs: false,
  model: {
    prop: "value",
    event: "input",
  },
  name: "equipment-dropdown",
  data() {
    return {
      isLoading: false,
      modelTypeList: [],
      timeout: null,
      searchInput: "",
      timeoutLimit: 1000,
    };
  },
  props: {
    value: {
      type: [String, Number, Object],
      default: null,
    },
     disabled: {
       type: Boolean,
      default: false,
    },
     loading: {
      type: Boolean,
      default: false,
    },
  
  },
  watch: {
    searchInput() {
      this.doTypingSearch();
    },
  },
  methods: {
    doTypingSearch() {
      this.isLoading = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.doSearch();
      }, this.timeoutLimit);
    },
    filterModelTypes(item, queryText) {
      const itemText = `${item?.name ?? ""}`;
      return (
        itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      );
    },
    doSearch() {
      const param = this.searchInput || "";
      if (param.length < 3) {
        this.isLoading = false;
        return;
      }
      const selectedModelType = this.modelTypeList.find(
        (row) => row.name === this.value
      );
      if (selectedModelType?.name && selectedModelType.name === param) {
        this.isLoading = false;
        return;
      }
      this.getModelTypes(param);
    },
    selectModelType(value) {
      this.searchInput = "";
      this.$nextTick(() => {
        this.$emit("input", value);
        this.$emit("change", value);
        const valObj = this.modelTypeList.find((row) => row.id === value);
        this.$emit("change:object", valObj);
      });
    },
    getModelTypes(search = "") {
      if (
        this.modelTypeList.length &&
        !search
      ) {
        this.isLoading = false;
        return;
      }
      this.isLoading = true;
      this.$store
        .dispatch(QUERY, {
          url: "machine-model-list",
          data: {
            search,
            value: this.value,
          },
        })
        .then(({ data }) => {
          this.modelTypeList = data;
        })
        .catch((error) => {
          this.$emit("error", error.message || "Failed to load machine");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  mounted() {
    if (!this.value || !this.modelTypeList.length) {
      this.getModelTypes();
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
};
</script>
